import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ToastrUtilityService } from '../../services/toastr-utility.service';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit, OnChanges {
  @Input() maxSize: number = 10 * 1024 * 1024; // Default 10MB
  @Input() acceptedTypes: string = '.pdf,.doc,.docx,.txt,.jpg,.jpeg,.png';
  @Input() documentData: any = null; // Existing document_json data
  @Input() label: string = 'Upload Document';
  @Input() showMaxSize: boolean = true;
  @Input() componentId: string = 'default';
  @Input() docLink: string = ''; // Download link for existing document
  @Input() documentName: string = ''; // Document name from node_form_data.name
  @Input() mode: string = ''; // edit or view
  @Output() documentUploaded = new EventEmitter<any>();
  @Output() documentRemoved = new EventEmitter<void>();

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;

  uploadedDocument: any = null;

  constructor(
    private _toastr: ToastrService,
    private _toastrUtility: ToastrUtilityService
  ) { }

  ngOnInit() {
    this.uploadedDocument = this.documentData;
  }

  ngOnChanges() {
    this.uploadedDocument = this.documentData;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    // Check file size
    if (file.size > this.maxSize) {
      const maxSizeMB = (this.maxSize / (1024 * 1024)).toFixed(0);
      this._toastr.error('', `File size exceeds ${maxSizeMB}MB limit`, this._toastrUtility.basic_configuration);
      // Reset file input
      event.target.value = '';
      return;
    }

    // Update Bootstrap custom file label
    const label = event.target.nextElementSibling;
    if (label) {
      label.textContent = file.name;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;
      // Remove data URL prefix (e.g., "data:application/pdf;base64,")
      const base64Data = base64String.split(',')[1] || base64String;
      
      const documentJson = {
        document_data: base64Data,
        document_name: file.name
      };

      this.uploadedDocument = documentJson;
      this.documentUploaded.emit(documentJson);
    };

    reader.onerror = () => {
      this._toastr.error('', 'Error reading file', this._toastrUtility.basic_configuration);
      event.target.value = '';
    };

    reader.readAsDataURL(file);
  }

  removeDocument(): void {
    this.uploadedDocument = null;
    // Reset file input and label
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
      // Reset Bootstrap custom file label
      const label = this.fileInput.nativeElement.nextElementSibling as HTMLLabelElement;
      if (label) {
        label.textContent = 'Choose file...';
      }
    }
    this.documentRemoved.emit();
  }

  getMaxSizeMB(): string {
    return (this.maxSize / (1024 * 1024)).toFixed(0);
  }
}
